import GridCardWrapper from './GridCardWrapper';

export default GridCardWrapper;
